const routes: Record<string, string> = {}

export { routes }
